import {SimpleBiEvent} from 'powtoon-commons/biTracker'
import {createLogger} from '../logging'

const logger = createLogger('bi-tracker')

const ELIGIBLE_BI_CATEGORY = 'ai_assistance'
const DEFAULT_FIELD_LENGTH = 50
const CUSTOM_FIELD_LENGTH: Partial<Record<keyof SimpleBiEvent, number>> = {
  extraData: 250
}

function validateProducerBIEvent(event: SimpleBiEvent) {
  if (!event.category?.startsWith(ELIGIBLE_BI_CATEGORY)) {
    logger.error(new Error('Ineligible event category was used'), {event})
    return false
  }

  if (!Object.keys(event).every((k: keyof SimpleBiEvent) =>
    JSON.stringify(event[k]).length < (CUSTOM_FIELD_LENGTH[k] || DEFAULT_FIELD_LENGTH))
  ) {
    logger.error(new Error('Invalid fields lengths provided'), {event})
    return false
  }

  return true
}

export function trackBiEvent(event: SimpleBiEvent) {

  if (!validateProducerBIEvent(event)) {
    return
  }

  const {category, action, value, label, extraData, ga4EventName} = event

  window.trackEventByParams(category, action, label, value, extraData, null, ga4EventName)
}

export function trackPageView(page: string) {
  window.trackPageView(page)
}